import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Modal from "components/modal/Modal";
import { Button } from "components/ui/button/Button";
import "./invalid-document-preview.scss";

interface InvalidDocumentProps {
  readonly onClose?: () => void;
  readonly fileId: string;
  readonly fileName: string;
  readonly fileUrl: string;
}

export default function InvalidDocumentPreview({ fileId, onClose, fileName, fileUrl }: InvalidDocumentProps) {
  return (
    <div className="invalid-document-preview">
      <Modal
        defaultHeader
        defaultHeaderIcon={solid("pen-nib")}
        defaultHeaderName={fileName}
        defaultHandleHide={onClose}
        defaultBody={false}
        footerContentPosition="right"
        customBody={
          <>
            {fileId ? (
              <DocViewer documents={[{ uri: fileUrl, fileName: fileName }]} pluginRenderers={DocViewerRenderers} />
            ) : (
              <h1>Oops! There's a problem viewing this document.</h1>
            )}
          </>
        }
        footer={
          <>
            <Button title={"Close"} type={"round"} variant={"outline-primary"} onClick={onClose} />
            <a href={fileUrl} download={fileName} target="_blank" rel="noreferrer">
              <Button title={"Download"} type={"round"} variant={"primary"} />
            </a>
          </>
        }
      />
    </div>
  );
}
